<template>
  <div class="item-group">
    <div class="item text-center">
      <h2>Published Projects</h2>
      <div>{{ publishedPorjects }}</div>
    </div>
    <div class="item">
      <h2>Total Participant Count</h2>
      <div>{{ totalParticipantCount }}</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex';
  export default {
    name: 'OverviewContainer',
    methods: {
      decimalCount(num) {
        const numToStr = num.toString();
        if (numToStr.includes('.')) return numToStr.split('.')[1].length;
        return 0;
      },
    },

    computed: {
      ...mapState('versions', ['authorProjects']),
      publishedPorjects() {
        return this.authorProjects.length;
      },
      totalParticipantCount() {
        return this.authorProjects.reduce(
          (accumulator, currentValue) => accumulator + currentValue.participantCount,
          0
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
 
  .item-group {
    display: flex;
    h2 {
      font-size: 1.5em;
    }
    h2 + div {
      font-size: 2em;
      line-height: 1;
      font-weight: lighter;
    }
    .item {
      text-align: center;
      padding: 30px;
      margin-bottom: 20px;
      border: 1px solid #ddd;
      -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
      box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
      flex-grow: 1;
      width: 50%;
    }
    .item:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .item:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
</style>
